export class UserRepository {
  async getUser(uid) {
    throw new Error('Method not implemented');
  }

  async createUser(user) {
    throw new Error('Method not implemented');
  }

  async updateUser(uid, userData) {
    throw new Error('Method not implemented');
  }

  async getUserPosts(uid) {
    throw new Error('Method not implemented');
  }

  async getUserParticipations(uid) {
    throw new Error('Method not implemented');
  }

  async followUser(followerId, followedId) {
    throw new Error('Method not implemented');
  }

  async unfollowUser(followerId, followedId) {
    throw new Error('Method not implemented');
  }
} 